export default "__VITE_ASSET__B5FSAJ5G__"